export default {
  createLog: 'Create Log',
  creating: 'Creating',
  save: 'Save',
  saving: 'Saving',
  saved: 'Saved',
  view: 'View',
  creatingFailed: 'Creating failed.',
  savingFailed: 'Saving failed.',
} as const;
